import { render, staticRenderFns } from "./CardStyle.vue?vue&type=template&id=195d1f8a"
import script from "./CardStyle.vue?vue&type=script&lang=js"
export * from "./CardStyle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('195d1f8a')) {
      api.createRecord('195d1f8a', component.options)
    } else {
      api.reload('195d1f8a', component.options)
    }
    module.hot.accept("./CardStyle.vue?vue&type=template&id=195d1f8a", function () {
      api.rerender('195d1f8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/back/Card/CardStyle.vue"
export default component.exports